/// <reference path="../types/index.d.ts" />

import '../client_forms/jacques4/style.css';
import FormStructure from './jacques4/form_structure';

export default FormStructure;